var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31593 0.547642C5.62783 -0.182547 6.72241 -0.182547 7.03431 0.547642L8.23086 3.34888C8.27457 3.45121 8.37569 3.52148 8.49214 3.53046L11.4977 3.76208C12.3126 3.82488 12.6482 4.78121 12.0342 5.29121L9.75356 7.18568C9.66916 7.25579 9.63175 7.36368 9.6559 7.46736L10.3852 10.5982C10.5674 11.3802 9.6337 11.9634 8.94301 11.4989L6.35424 9.7581C6.24703 9.686 6.10321 9.686 5.996 9.7581L3.40723 11.4989C2.71654 11.9634 1.78285 11.3802 1.96503 10.5981L2.69434 7.46736C2.71849 7.36368 2.68108 7.25579 2.59668 7.18568L0.31593 5.29122C-0.298048 4.78123 0.037494 3.82488 0.85244 3.76208L3.8581 3.53046C3.97455 3.52148 4.07567 3.45121 4.11938 3.34888L5.31593 0.547642Z",
    fill: "none",
    stroke: "#FFCE21",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmptyIcon);
export default __webpack_public_path__ + "static/media/star-empty-icon.fe16d09bdd34a6d3b5782b9c33485969.svg";
export { ForwardRef as ReactComponent };